import { render, staticRenderFns } from "./yszCensus.vue?vue&type=template&id=85fda736&scoped=true&"
import script from "./yszCensus.vue?vue&type=script&lang=js&"
export * from "./yszCensus.vue?vue&type=script&lang=js&"
import style0 from "./yszCensus.vue?vue&type=style&index=0&id=85fda736&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fda736",
  null
  
)

export default component.exports